const actions = {
  set: 'SET::PASS_TYPES',
}

export const setPassTypes = passTypes => ({ type: actions.set, passTypes })

export default actions
